import { Injectable } from '@angular/core';
import { AppSettingsService } from '../appSettings/AppSettingsService';
import { IThemePreferenceService } from '../config/typings/services';

@Injectable({
    providedIn: 'root'
})
export class ThemePreferenceService implements IThemePreferenceService {
    public static $name: string = 'themePreferenceService';

    constructor(
        private appSettingsService: AppSettingsService
    ) {
    }

    public getThemePreference() {
        let metadata = this.appSettingsService.getMetadata();

        return metadata.theme;
    }
}
